var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFav({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.52867 3.5492C10.2617 1.09387 13.7388 1.09387 14.4719 3.5492L15.711 7.69967L20.0413 7.5956C22.603 7.53404 23.6774 10.841 21.5688 12.2969L18.0044 14.7579L19.4415 18.8441C20.2916 21.2614 17.4786 23.3052 15.4423 21.7496L12.0003 19.1202L8.55821 21.7496C6.52195 23.3052 3.70891 21.2614 4.55906 18.8441L5.99615 14.7579L2.43174 12.2969C0.32311 10.841 1.3976 7.53404 3.95928 7.5956L8.28952 7.69967L9.52867 3.5492Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFav);
export default __webpack_public_path__ + "static/media/fav.4e7cd872f5fbc844131952cb885026ec.svg";
export { ForwardRef as ReactComponent };